// extracted by mini-css-extract-plugin
module.exports = {"grid":"VolumeOneWords_grid__oNYMM","zoomIcon":"VolumeOneWords_zoomIcon__1Yl6C","radicalInfoBar":"VolumeOneWords_radicalInfoBar__1izzO"};